import { render } from "./FastSearchSwitcher.vue?vue&type=template&id=3f614646&scoped=true"
import script from "./FastSearchSwitcher.vue?vue&type=script&lang=js"
export * from "./FastSearchSwitcher.vue?vue&type=script&lang=js"

import "./FastSearchSwitcher.vue?vue&type=style&index=0&id=3f614646&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f614646"]])

export default __exports__